import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/largeLogo.png'


const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "login_content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "login_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_5 = { class: "login_input" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", null, "로그인", -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "id_input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.id) = $event)),
              placeholder: "아이디"
            }, null, 512), [
              [_vModelText, $setup.state.id]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.password) = $event)),
              placeholder: "비밀번호"
            }, null, 512), [
              [_vModelText, $setup.state.password]
            ])
          ]),
          _createElementVNode("div", {
            class: "login_btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.login && $setup.login(...args)))
          }, _hoisted_7)
        ])
      ])
    ])
  ]))
}